
const types = {
    authCheckingFinish: '[auth] Finish checking login state',
    authStartLogin: '[auth] Start login',
    authLogin: '[auth] Login',
    authStartRegister: '[auth] Start Register',
    authStartStartTokenRenew: '[auth] Start token renew',
    authPreRegistration: '[auth] Pre-registration Data',
    authLogout: '[auth] Logout',

    saveDepartmentsAndMunicipalities: '[DepartmentsAndMunicipalities] Save Data',

    preRegistrationFormSaveData: '[pre-registration] Save Data',
    deletePreRegistrationData: '[pre-registration] Delete',

    saveInscriptionFormData: '[inscription] Save Data',
    deleteInscriptionData: '[pre-registration] Delete'
}

export default types;